import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@mui/material';
import { Icon } from '@/components/shared/icon';
export type TagStatus = 'active' | 'inactive' | 'pending' | 'error';
export const StatusTag = t0 => {
  const $ = _c(18);
  const {
    status,
    label,
    icon
  } = t0;
  const backgroundColor = status === "active" ? "var(--mui-palette-success-opacity)" : status === "inactive" ? "var(--mui-palette-background-default)" : status === "pending" ? "var(--mui-palette-custom-ORANGE-07)" : "var(--mui-palette-background-default)";
  const color = status === "active" ? "var(--mui-palette-success-main)" : status === "inactive" ? "var(--mui-palette-custom-GREY-01)" : status === "pending" ? "var(--mui-palette-custom-ORANGE-01)" : "var(--mui-palette-custom-GREY-01)";
  let t1;
  if ($[0] !== backgroundColor) {
    t1 = {
      borderRadius: "4px",
      height: "32px",
      width: "auto",
      fontWeight: 500,
      backgroundColor
    };
    $[0] = backgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      justifyContent: "space-evenly"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingLeft: "4px"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== color || $[5] !== icon) {
    t4 = <Box sx={t3}><Icon color={color} iconClass={icon} /></Box>;
    $[4] = color;
    $[5] = icon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== color) {
    t5 = {
      fontSize: "12px",
      height: "32px",
      paddingRight: "12px",
      fontWeight: 500,
      lineHeight: "32px",
      color
    };
    $[7] = color;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== label || $[10] !== t5) {
    t6 = <Box sx={t5}>{label}</Box>;
    $[9] = label;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <Stack direction="row" sx={t2}>{t4}{t6}</Stack>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <Box sx={t1}>{t7}</Box>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};